import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EmailSendService {


  url = environment.serverAPI9 + "/api/emails";

  url1 = environment.serverAPI9 + "/api";

  constructor(private http: HttpClient) { }

  getAllEmailSend(Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }

  getAllEmailSendByLeadId(leadId: string, type: any, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/lead/all/${leadId}/${type}?page=${Page}&size=${size}&sort=${sort}`);
  }

  getAllInboundEmail(fromAddress: string, toAddress: string, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url1}/inbound/${fromAddress}/${toAddress}?page=${Page}&size=${size}&sort=${sort}`);
  }

  getAllEmailSendDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }


  getEmailSendById(id: number): Observable<Object> {
    return this.http.get(`${this.url}/${id}`);
  }

  addOrEmailSend(emails: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, emails);
  }

  EmailSendSearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }


  deleteByEmailSendId(id: any): Observable<Object> {
    return this.http.delete(`${this.url}/${id}`);
  }

  getAllEmailByLeadId(leadId: number): Observable<Object> {
    return this.http.get(`${this.url}/lead/${leadId}`);
  }

  SendEmail(email: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url1}/send-email/new`, email);
  }

  getAllEmailByOwnerId(ownerId: number): Observable<Object> {
    return this.http.get(`${this.url}/owner/${ownerId}`);
  }

  markasReplied(id: any): Observable<any> {
    return this.http.post(`${this.url1}/update/replyCount/${id}`, {});
  }

  getEmailSendByTrackingId(id: number): Observable<Object> {
    return this.http.get(`${this.url}/tracking/link/${id}`);
  }

}
